import axiosInstance from "./axiosInstance";

export const modificarMembresia = async (id, idMembresia, precio, precioM2) => {
  return await axiosInstance.put(
    `${process.env.REACT_APP_BASE_URL}/modificarMembresia`,
    { id, idMembresia, precio, precioM2 },
    { withCredentials: true }
  );
};

export const crearMembresia = async (tipo, precio, precioM2, inicioPeriodo, finPeriodo) => {
  return await axiosInstance.post(
    `${process.env.REACT_APP_BASE_URL}/modificarMembresia`,
    { tipo, precio, precioM2, inicioPeriodo, finPeriodo },
    { withCredentials: true }
  );
}

export const deleteMembresia = async (id) => {
  return await axiosInstance.delete(
    `${process.env.REACT_APP_BASE_URL}/modificarMembresia?id=${id}`,
    {
      withCredentials: true,
    }
  );
}